import type { BlogPost } from '../types'

const post: BlogPost = {
  title: 'Fallow',
  slug: 'fallow',
  category: 'Fallow',
  date: '2025-04-30',
  image: 'https://dpnelson.com/wp-content/uploads/2025/04/blogs-1.webp',
  excerpt: 'In farming, crops and livestock need to be rotated to keep a field healthy and full of nutrients for the fruits and vegetables to grow. Part of this cycle is…',
  body: `In farming, crops and livestock need to be rotated to keep a field healthy and full of nutrients for the fruits and vegetables to grow. Part of this cycle is a fallow period, when a field is left unused for a season or a year. This allows the field to heal and replenish its nutrients.

In human terms, we have cycles of various productivity and regenerative rest. We breathe in, we breathe out. We work during the day, we rest in the evening. We take the weekend off. We take a vacation once in a while.

In other words, we rest and regenerate.

Sometimes we go through unexpected fallow periods. We realize one day that we need to stop procrastinating. We need to grow in an area (eat right, exercise, read more, etc.) that we've been neglecting.

And we usually beat ourselves up for not getting to it sooner.

How about this for a perspective? Instead of feeling bad about a lack of balance, be grateful for a fallow period that is letting you know it's time to get back to work.

Then, get back to work.`,
}

export default post
